import './style.scss';

const Header: React.FC = () => {
    return (
        <div className="trust-header-container">
            <h2 className="title">{__('Trusted Contact Person')}</h2>
            <p className="desc mb-0">
                {__(
                    'Anyone who’s at least 18 years old can be a Trusted Contact, but we suggest designating a person who isn’t already authorized to conduct business or receive information on your behalf. '
                )}
            </p>
            <p className="desc">
                {__(
                    'Trusted Contacts are usually family members or close friends – people you trust and who are likely to be in the best position to know your current situation'
                )}
            </p>
        </div>
    );
};

export default Header;
